import { RowData } from "@tanstack/react-table";

import { IList } from "src/core/lists/api/lists.api";

import { supportTicketStatusColumn } from "./columns/supportTicketStatusColumn";
import { supportTicketPriorityColumn } from "./columns/supportTicketPriorityColumn";
import {
  standardTextColumn,
  numberColumn,
  priceColumn,
  timeColumn,
  dateColumn,
  actionColumn,
  scheduleColumn,
  listQuantityColumn,
  scheduleStatusColumn,
  listTotalColumn,
  orderStatusColumn,
  orderTypeColumn,
  productCountColumn
} from "./columns";
import { customerColumn } from "./columns/customerColumn";
import { dropColumn } from "./columns/dropColumn";
import { supportTicketAssignedColumn } from "./columns/supportTicketAssignedColumn";
import { supportTicketOriginColumn } from "./columns/supportTicketOriginColumn";
import { checkboxColumn } from "./columns/checkBoxColumn";

export type CustomColumnHelper<TData extends RowData> = {
  standardTextColumn: typeof standardTextColumn<TData>;
  numberColumn: typeof numberColumn<TData>;
  priceColumn: typeof priceColumn<TData>;
  timeColumn: typeof timeColumn<TData>;
  dateColumn: typeof dateColumn<TData>;
  actionColumn: typeof actionColumn<TData>;
  scheduleColumn: typeof scheduleColumn;
  listQuantityColumn: typeof listQuantityColumn;
  scheduleStatusColumn: typeof scheduleStatusColumn<TData extends IList ? IList : undefined>;
  listTotalColumn: typeof listTotalColumn;
  orderStatusColumn: typeof orderStatusColumn<TData>;
  orderTypeColumn: typeof orderTypeColumn<TData>;
  productCountColumn: typeof productCountColumn<TData>;
  customerColumn: typeof customerColumn<TData>;
  dropColumn: typeof dropColumn<TData>;
  supportTicketStatusColumn: typeof supportTicketStatusColumn<TData>;
  supportTicketPriorityColumn: typeof supportTicketPriorityColumn<TData>;
  supportTicketAssignedColumn: typeof supportTicketAssignedColumn<TData>;
  supportTicketOriginColumn: typeof supportTicketOriginColumn<TData>;
  checkboxColumn: typeof checkboxColumn<TData>;
};

export const customCreateColumnHelper = <TData extends RowData>(): CustomColumnHelper<TData> => {
  return {
    standardTextColumn,
    numberColumn,
    priceColumn,
    timeColumn,
    dateColumn,
    actionColumn,
    scheduleColumn,
    listQuantityColumn,
    scheduleStatusColumn,
    listTotalColumn,
    orderStatusColumn,
    orderTypeColumn,
    productCountColumn,
    customerColumn,
    dropColumn,
    supportTicketStatusColumn,
    supportTicketPriorityColumn,
    supportTicketAssignedColumn,
    supportTicketOriginColumn,
    checkboxColumn
  };
};
